const map = {
	"./message_de.json": [
		639,
		[
			639
		]
	],
	"./message_en.json": [
		447,
		[
			447
		]
	],
	"./message_es.json": [
		552,
		[
			552
		]
	],
	"./message_ru.json": [
		17,
		[
			17
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 632;
module.exports = webpackAsyncContext;